module.exports = __webpack_public_path__ + "static/media/car3.6c3eb006.png";